import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import ruralPropertyDeleteAction from './ruralPropertyDelete.action.json' assert { type: 'json' }

const ruralPropertyDeleteDefinition = defineAction({
  ...ruralPropertyDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default ruralPropertyDeleteDefinition
